<!-- Email Report popup start here -->
<div class="w-full">
    <p-drawer [(visible)]="visible" class="emailRepForm" position="right" [style]="{width: '65vw'}" (onhide)="onCancel()">

        <!-- Header Template -->
        <ng-template pTemplate="header">
            <div style="width: 94%;">
                <div>Email Report</div>
                <div class="sbSubTtl mt-1">(Send this report via email to selected recipients)</div>
            </div>
        </ng-template>

        <!-- Main Content -->
        <div *ngIf="isComponentLoading" class="text-center p-4">
            <i class="pi pi-spin pi-spinner text-4xl text-gray-400 mb-3"></i>
            <p class="text-gray-600">Loading email form...</p>
        </div>
        
        <form *ngIf="!isComponentLoading" [formGroup]="emailForm" (ngSubmit)="onSubmit()">   
            <div class="sectWB">
                <div class="sectLab mb-3">Email Details</div>
                
                <!-- To Field -->
                <div class="field mb-4">
                    <label for="toEmails" class="block mb-2">To <span class="text-red-500">*</span></label>
                    <p-multiselect [options]="userOptions" formControlName="toEmails" 
                                placeholder="Select Notifiers" optionLabel="name" optionValue="code" 
                                display="chip" [filter]="true" class="w-full" />
                    <small class="p-error" *ngIf="emailForm.get('toEmails')?.invalid && emailForm.get('toEmails')?.touched">
                        Please select at least one recipient
                    </small>
                    <small class="text-gray-500" *ngIf="emailForm.get('toEmails')?.valid && emailForm.get('toEmails')?.value?.length > 0">
                        {{emailForm.get('toEmails')?.value?.length}} recipient(s) selected
                    </small>
                </div>

                <!-- Subject Field -->
                <div class="field mb-4">
                    <label for="subject" class="block mb-2">Subject <span class="text-red-500">*</span></label>
                    <input 
                        id="subject"
                        type="text" 
                        pInputText 
                        formControlName="subject"
                        placeholder="Enter email subject"
                        class="w-full"
                        maxlength="200" />
                    <small class="p-error" *ngIf="emailForm.get('subject')?.invalid && emailForm.get('subject')?.touched">
                        <span *ngIf="emailForm.get('subject')?.errors?.['required']">Subject is required</span>
                        <span *ngIf="emailForm.get('subject')?.errors?.['maxlength']">Subject cannot exceed 200 characters</span>
                    </small>
                    <small class="text-gray-500" *ngIf="emailForm.get('subject')?.valid">
                        {{emailForm.get('subject')?.value?.length || 0}}/200 characters
                    </small>
                </div>

                <!-- Body Field -->
                <div class="field mb-4">
                    <label for="mailBody" class="block mb-2">Message Body <span class="text-red-500">*</span></label>
                    <p-editor 
                        #editor
                        id="mailBody"
                        formControlName="mailBody"
                        [style]="{'height':'200px'}"
                        placeholder="Enter your message here...">
                        <ng-template pTemplate="header">
                            <span class="ql-formats">
                                <button class="ql-bold" aria-label="Bold"></button>
                                <button class="ql-italic" aria-label="Italic"></button>
                                <button class="ql-underline" aria-label="Underline"></button>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-list" value="ordered" aria-label="Ordered List"></button>
                                <button class="ql-list" value="bullet" aria-label="Unordered List"></button>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-link" aria-label="Insert Link"></button>
                            </span>
                        </ng-template>
                    </p-editor>
                    <small class="p-error" *ngIf="emailForm.get('mailBody')?.invalid && emailForm.get('mailBody')?.touched">
                        Message body is required
                    </small>
                </div>
            </div>

            <!-- Footer Actions -->
            <div class="flex justify-content-end gap-2 mt-4">
                <p-button 
                    type="submit" 
                    label="Send Email" 
                    severity="primary"
                    [loading]="isSubmitting"
                    [disabled]="emailForm.invalid || isSubmitting">
                </p-button>
                <p-button 
                    type="button" 
                    label="Cancel" 
                    [outlined]="true" 
                    severity="secondary"
                    (onClick)="onCancel()"
                    [disabled]="isSubmitting">
                </p-button>
                
            </div>
        </form>
    </p-drawer>
</div> 